// import logo from "./asset-source/logo.gif";
import logo2 from "./asset-source/logo-wjet.svg";
import toggle from "./asset-source/toggle.svg";
import banner from "./asset-source/banner.svg";
import arr from "./asset-source/arr.svg";
import arrV from "./asset-source/arr-v.svg";
import eq from "./asset-source/eq.svg";
import salt from "./asset-source/salt.svg";
import shar from "./asset-source/logoSharx.svg";
import gd from "./asset-source/gd.svg";
import eesee from "./asset-source/eesee.svg";
import onecarlogo from "./asset-source/onecarlogo.svg";
import logochin from "./asset-source/logochin.svg";
import binlogo from "./asset-source/binlogo.svg";
import binCase from "./asset-source/binCase.jpg";
import onecarkeys from "./asset-source/onecarkeys.png";
import chinchingo from "./asset-source/caseChinChinUI.jpg";
import vmestecover from "./asset-source/vmeste-wjet-cover.jpg";
import vmestelogo from "./asset-source/vmeste-logo.svg";

import plane from "./asset-source/plane.svg";
import planewjet from "./asset-source/planewjetbg.png";

import s1 from "./asset-source/service.png";
import s2 from "./asset-source/ecommerce.png";
import s3 from "./asset-source/corporate.png";
import s4 from "./asset-source/crypto.png";
import s5 from "./asset-source/trading.png";
import s6 from "./asset-source/crm-erm.png";

import s1h from "./asset-source/service-h.png";
import s2h from "./asset-source/ecommerce-h.png";
import s3h from "./asset-source/corporate-h.png";
import s4h from "./asset-source/crypto-h.png";
import s5h from "./asset-source/trading-h.png";
import s6h from "./asset-source/crm-erm-h.png";

import ez from "./asset-source/ez.gif";

import logoW from "./asset-source/logo-w.svg";
import close from "./asset-source/close.svg";
import farrow from "./asset-source/footer-arr.svg";

//cases
import caseBoost from "./asset-source/boostpad-case.png";
import logoboostpad from "./asset-source/boostpadlogo.svg";

import caseSharxDesignSystem from "./asset-source/sharx-dc-cover.png";

import case1 from "./asset-source/case1.jpg";
import case2 from "./asset-source/case2.jpg";
import case3 from "./asset-source/case3.jpg";
import case4 from "./asset-source/case4.jpg";
import case5 from "./asset-source/case5.jpg";

import footer from "./asset-source/footer.png";
import { useState, useEffect } from "react";
import Slider from "react-slick";
import { Header } from "./components/header-new/header";
import { Footer } from "./components/footer/footer";

import sl1 from "./asset-source/sl1.svg";
import sl2 from "./asset-source/sl2.svg";
import sl3 from "./asset-source/sl3.svg";
import sl4 from "./asset-source/sl4.svg";
import sl5 from "./asset-source/sl5.svg";
import sl6 from "./asset-source/sl6.svg";
import sl7 from "./asset-source/sl7.svg";
import sl8 from "./asset-source/sl8.svg";

import ContactUsModal from "./components/modal/contact-us";
import { useNavigate } from "react-router-dom";

function App() {
	const [fullProjects, setFullProjects] = useState(false);
	const [currentField, setCurrentField] = useState("");
	const navigate = useNavigate();

	const scrollToCases = window.location.href.includes("#cases");

	useEffect(() => {
		if (scrollToCases) {
			let elem = document.getElementById("cases");
			elem.scrollIntoView({ block: "start", behavior: "smooth" });
		}
	}, []);

	document.title = "Wjet - Дизайн цифровых продуктов";
	document.getElementsByTagName("META")[2].content =
		"Студия цифрового дизайна Wjet — аудит, проектирование и UI/UX дизайн мобильных приложений, веб-сервисов и интернет-магазинов для вашего бизнеса";

	document.getElementsByTagName("META")[3].content =
		"UX-исследования, Юзабилити-аудит, UX аудит, Дизайн интерфейсов, UX/UI проектирование, UI/UX дизайн, UI/UX для цифровых продуктов, Дизайн интерфейсов для приложений, Интерактивный прототип, Веб-дизайн, Адаптивный веб-дизайн, Создание MVP, Дизайн-система продукта";

	const settings = {
		dots: false,
		infinite: true,
		arrows: true,
		slidesToShow: 6,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 14000,
		cssEase: "linear",
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	// setInterval(() => {
	//   shine();
	// }, 15005);

	// useEffect(() => {
	// 	if (window.location.href.includes("?modal")) {
	// 		document.body.style.overflow = "hidden";
	// 	} else {
	// 		document.body.style.overflow = "auto";
	// 	}
	// }, []);

	return (
		<div
			className="App"
			onClick={() => {
				setCurrentField("");
			}}
		>
			<Header onLight isTitlePage />

			<section className="mainpage__top" id="top">
				{/* <img src={bigW} alt="" className="big-w" /> */}

				<div className="dotz">
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item shine"></div>
						<div className="dotz__item unshine delay2"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine unshine4"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine4"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item shine4"></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item shine"></div>
						<div className="dotz__item shine delay3"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine delay1"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item shine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item"></div>
						<div className="dotz__item unshine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine delay2"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine delay3"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item unshine delay2"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item unshine delay2"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item shine4"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine delay3"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item inshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine delay3"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay2"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item unshine delay2"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item shine"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item inshine delay2"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item shine4"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine delay1"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item shine delay3"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item shine delay2"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine delay4"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine4"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
				</div>
				<div className="container">
					<div className="left">
						<h1 className="h1 h1--main">
							Дизайн
							<br />
							цифровых
							<br />
							продуктов <img src={toggle} alt="" className="toggle" />
						</h1>
						<p className="top__text">
							Мы&nbsp;превращаем сложные интерфейсы в&nbsp;понятные
							и&nbsp;удобные.
							<br />
							Ваши клиенты получают лучший опыт. <br />
							Продукт улучшает метрики. Бизнес получает прибыль.
						</p>
					</div>

					<div className="right">
						<div className="big-plane">
							<img src={planewjet} alt="" className="big-plane-img" />
						</div>
					</div>

					<a className="top__banner">
						<div className="icon">
							<img src={banner} alt="" />
						</div>
						<div>
							<button
								onClick={() => {
									navigate(`?modal`);
								}}
							>
								Разрабатываем дизайн системы
							</button>
						</div>
						<img src={arr} alt="" className="arr" />
					</a>
				</div>
			</section>

			<section className="cases mainpage__cases" id="cases">
				<div className="container">
					<h2 className="h2">Кейсы</h2>
					<a
						href="/boostpad-ux-ui-launchpad"
						className="case__item"
						target="_blank"
						rel="noreferrer"
					>
						<div className="case__info">
							<h3 className="case__title">
								BoostPad: UX/UI дизайн для криптолаунчпада
							</h3>
							<div className="case__button">
								<img src={logoboostpad} alt="" />
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic">
							<img
								src={caseBoost}
								alt="Кейс BoostPad — UX/UI дизайн криптолаунчпада"
							/>
						</div>
					</a>

					<a
						href="/web3-eq-product-page"
						className="case__item"
						target="_blank"
						rel="noreferrer"
					>
						<div className="case__info">
							<h3 className="case__title">
								Децентрализованная крипто биржа универсальных инструментов
							</h3>
							<div className="case__button">
								<img src={eq} alt="" />
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic">
							<img
								src={case1}
								alt="Кейс децентрализованной криптобиржи универсальных инструментов Equilibrium"
							/>
						</div>
					</a>

					<a href="/sharx-design-system" target="_blank" className="case__item">
						<div className="case__info">
							<h3 className="case__title">
								Дизайн-система для Sharx DC - ускорение разработки и единый
								стиль продуктов
							</h3>

							<div className="case__button">
								<img src={shar} alt="" />

								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>

						<div className="case__pic">
							<img
								src={caseSharxDesignSystem}
								alt="Кейс дизайн-системы для Sharx DC"
							/>
						</div>
					</a>

					<a href="/chin-chin" target="_blank" className="case__item">
						<div className="case__info">
							<h3 className="case__title">
								GoChinChin это приложение по поиску встреч и общения с
								единомышленниками в комфортной и непринужденной атмосфере.
							</h3>

							<div className="case__button">
								<img src={logochin} alt="" />

								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>

						<div className="case__pic">
							<img
								src={chinchingo}
								alt="Кейс GoChinChin — приложения для поиска встреч и общения"
							/>
						</div>
					</a>

					<a
						href="https://www.x5.ru/ru/news/x5-dobavit-salt-v-oblachnye-tehnologii/"
						target="_blank"
						className="case__item"
						rel="noreferrer"
					>
						<div className="case__info">
							<h3 className="case__title">
								X5 Group. Salt.Облачная платформа центров обработки данныx
							</h3>
							<div className="case__button">
								<img src={salt} alt="" />
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic">
							<img
								src={case2}
								alt="Кейс X5 Group Salt — облачной платформы центров обработки данных"
							/>
						</div>
					</a>

					<a
						href="https://sharxdc.ru"
						target="_blank"
						rel="noreferrer"
						className="case__item"
					>
						<div className="case__info">
							<h3 className="case__title">
								Масштабируемая программно-аппаратная платформа виртуализации
							</h3>
							<div className="case__button">
								<img src={shar} alt="" />
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic">
							<img
								src={case3}
								alt="Кейс масштабируемой программно-аппаратной платформы виртуализации Sharx DC"
							/>
						</div>
					</a>

					<a href="/vmeste" target="_blank" className="case__item">
						<div className="case__info">
							<h3 className="case__title">
								Разработка UX/UI дизайна для приложения «В.месте»
							</h3>

							<div className="case__button">
								<img src={vmestelogo} alt="" />

								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>

						<div className="case__pic">
							<img
								src={vmestecover}
								alt="Кейс разработки UX/UI дизайна для приложения «В.месте»"
							/>
						</div>
					</a>

					<a
						href="https://eesee.io"
						rel="noreferrer"
						target="_blank"
						className="case__item"
					>
						<div className="case__info">
							<h3 className="case__title">
								Ускорение продаж, снижение ценового барьера для выхода на рынок
								Web3 (rwa, NFT, tokens). Launchpad платформа{" "}
							</h3>
							<div className="case__button">
								<img src={eesee} alt="" />
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic case__pic--ez">
							<img src={ez} alt="Кейс Launchpad платформы для Web3 Eesee" />
						</div>
					</a>

					<a
						href="http://goodday.work"
						rel="noreferrer"
						target="_blank"
						className="case__item"
					>
						<div className="case__info">
							<h3 className="case__title">
								Платформа управления работой. Инструменты для планирования,
								управления проектами и продуктами
							</h3>
							<div className="case__button">
								<img src={gd} alt="" />
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic">
							<img
								src={case4}
								alt="Проект GoodDay — платформы для управления проектами и продуктами"
							/>
						</div>
					</a>

					<a
						href="https://onecarservice.ru"
						target="_blank"
						className="case__item"
						rel="noreferrer"
					>
						<div className="case__info">
							<h3 className="case__title">
								OneCar — маркетплейс товаров и услуг для автомобилей
							</h3>
							<div className="case__button">
								<img src={onecarlogo} alt="" />
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic">
							<img
								src={onecarkeys}
								alt="Проект OneCar — проектирование и дизайн маркетплейса товаров и услуг для автомобилей"
							/>
						</div>
					</a>

					<a
						href="/invest"
						target="_blank"
						rel="noreferrer"
						className="case__item"
					>
						<div className="case__info">
							<h3 className="case__title">
								BIN - платформа для понятных и разумных инвестиций
							</h3>
							<div className="case__button">
								<img src={binlogo} alt="" />
								{/* <div className="projects__soon">Скоро</div> */}
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic">
							<img
								src={binCase}
								alt="Кейс BIN — платформы для разумных и понятных инвестиций"
							/>
						</div>
					</a>

					{/* <a
						href="https://apps.apple.com/app/goodday-work/id1343674351"
						target="_blank"
						className="case__item"
						rel="noreferrer"
					>
						<div className="case__info">
							<div className="case__title">
								Мобильное приложение для платформы управления проектами,
								продуктами, командами
							</div>
							<div className="case__button">
								<img src={gd} alt="" />
								<img src={arrV} alt="" className="arr-v" />
							</div>
						</div>
						<div className="case__pic">
							<img src={case5} alt="" />
						</div>
					</a> */}
				</div>
			</section>

			<section className="projects" id="projects">
				<div className="container">
					<div className="projects__title">
						<img src={plane} alt="" />
						Все проекты
					</div>

					<div
						className={
							fullProjects ? "full projects__wrapper" : "projects__wrapper"
						}
					>
						<div className="projects__item">
							<div className="projects__name">uktlab</div>
							<div className="projects__desc">
								Современная система речевой аналитики для uktlab.ru
							</div>
							<a
								href="https://uktlab.ru"
								className="projects__button"
								target="_blank"
								rel="noreferrer"
							>
								Перейти
								<img src={arrV} alt="" />
							</a>
						</div>

						<div className="projects__item">
							<div className="projects__name">PRO-BIKE</div>
							<div className="projects__desc">
								Ведущая компания на велорынке. Интернет-магазин
							</div>
							<a
								href="https://pro-bike.ru"
								className="projects__button"
								target="_blank"
								rel="noreferrer"
							>
								Перейти
								<img src={arrV} alt="" />
							</a>
						</div>
						<div className="projects__item">
							<div className="projects__name">rentskill</div>
							<div className="projects__desc">
								Платформа аренды жилья посуточно
							</div>
							<a
								href="https://rentskill.ru"
								className="projects__button"
								target="_blank"
								rel="noreferrer"
							>
								Перейти
								<img src={arrV} alt="" />
							</a>
						</div>
						<div className="projects__item">
							<div className="projects__name">Мебель без переплат</div>
							<div className="projects__desc">
								Первый в России. Сервис мебельных услуг без посредников
							</div>
							<div className="projects__soon"> Скоро</div>
						</div>

						<div className="projects__item">
							<div className="projects__name">genshiro.io</div>
							<div className="projects__desc">
								DeFi platform with high leverage
							</div>
							<a
								href="https://genshiro.io/en"
								className="projects__button"
								target="_blank"
								rel="noreferrer"
							>
								Перейти
								<img src={arrV} alt="" />
							</a>
						</div>

						<div className="projects__item">
							<div className="projects__name">TON kitties</div>
							<div className="projects__desc">
								Telegram кликер. Заведи крипто-котика
							</div>
							<div className="projects__soon"> Скоро</div>
						</div>
					</div>

					<button
						className="btn showmore"
						onClick={() => {
							setFullProjects(!fullProjects);
						}}
					>
						Показать {fullProjects ? "меньше" : "еще"}
					</button>
				</div>
			</section>

			<section className="products" id="products">
				<div className="container">
					<h2 className="products__title">Продукты, которые мы дизайним</h2>
					<div className="products__grid">
						<div className="products__column">
							<div className="products__card corp">
								<div className="products__hover">
									<div className="dotz">
										<div className="dotz__row">
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item inshune delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item"></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
									</div>
								</div>
								<div className="products__icon">
									<img src={s3} alt="" className="products__icon--main" />
									<img src={s3h} alt="" className="products__icon--sub" />
								</div>
								<div>
									<div className="products__cardtitle">
										Корпоративные продукты (b2b)
									</div>
									<div className="products__description">
										Продукты рожденные для бизнеса мы сделаем простыми и
										понятными
									</div>
								</div>
							</div>
							<div className="products__card">
								<div className="products__hover">
									<div className="dotz">
										<div className="dotz__row">
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item inshune delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item"></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
									</div>
								</div>
								<div className="products__icon">
									<img src={s4} alt="" className="products__icon--main" />
									<img src={s4h} alt="" className="products__icon--sub" />
								</div>
								<div>
									<div className="products__cardtitle">
										Крипто-проекты и web3
									</div>
									<div className="products__description">
										Мы говорим на одном языке. Web3. DeFi. Staking. Airdrop.
										NFT. ICO. IDO.
									</div>
								</div>
							</div>
						</div>
						<div className="products__column">
							<div className="products__card">
								<div className="products__hover">
									<div className="dotz">
										<div className="dotz__row">
											<div className="dotz__item shine"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item inshune delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item"></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
									</div>
								</div>
								<div className="products__icon">
									<img src={s1} alt="" className="products__icon--main" />
									<img src={s1h} alt="" className="products__icon--sub" />
								</div>
								<div>
									<div className="products__cardtitle">Сервисы (b2c)</div>
									<div className="products__description">
										Удобные для пользователей с любым уровнем подготовки.
									</div>
								</div>
							</div>
							<div className="products__card">
								<div className="products__hover">
									<div className="dotz">
										<div className="dotz__row">
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item inshune delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item"></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
									</div>
								</div>
								<div className="products__icon">
									<img src={s2} alt="" className="products__icon--main" />
									<img src={s2h} alt="" className="products__icon--sub" />
								</div>
								<div>
									<div className="products__cardtitle">Маркетплейсы</div>
									<div className="products__description">
										Электронная комерция будущего.
									</div>
								</div>
							</div>
						</div>
						<div className="products__column">
							<div className="products__card">
								<div className="products__hover">
									<div className="dotz">
										<div className="dotz__row">
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item inshune delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item"></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
									</div>
								</div>
								<div className="products__icon">
									<img src={s5} alt="" className="products__icon--main" />
									<img src={s5h} alt="" className="products__icon--sub" />
								</div>
								<div>
									<div className="products__cardtitle">
										Торговые терминалы и биржи
									</div>
									<div className="products__description">
										Инвестиции, аналитика, торговые роботы и трейдинг.
									</div>
								</div>
							</div>
							<div className="products__card">
								<div className="products__hover">
									<div className="dotz">
										<div className="dotz__row">
											<div className="dotz__item"></div>
											<div className="dotz__item shine delay3"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine"></div>
											<div className="dotz__item shine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item inshune delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item shine delay2"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine delay3"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item"></div>
											<div className="dotz__item unshine4"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item shine"></div>
											<div className="dotz__item unshine delay1"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
										</div>
										<div className="dotz__row">
											<div className="dotz__item "></div>
											<div className="dotz__item"></div>
											<div className="dotz__item unshine"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item"></div>
											<div className="dotz__item dotz__item--empty"></div>
											<div className="dotz__item"></div>
										</div>
									</div>
								</div>
								<div className="products__icon">
									<img src={s6} alt="" className="products__icon--main" />
									<img src={s6h} alt="" className="products__icon--sub" />
								</div>
								<div>
									<div className="products__cardtitle">
										Системы управление проектами и командами
									</div>
									<div className="products__description">
										Планирование и аналитика проектов. Аналитика. Ганты. Борды.
										Задачи.
									</div>
								</div>
							</div>
							<button
								className="btn"
								onClick={() => {
									navigate(`?modal`);
								}}
							>
								Работать с нами
							</button>
						</div>
					</div>
				</div>
			</section>

			<section className="design" id="design">
				<div className="dotz">
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine delay3"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine delay2"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay3"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine delay2"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item unshine delay1"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item unshine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay3"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine4"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item "></div>
						<div className="dotz__item unshine delay2"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item shine delay3"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine delay2"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item shine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item shine delay3"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item dotz__item--empty"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="dotz__item"></div>
						<div className="dotz__item unshine delay2"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine delay1"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
						<div className="dotz__item unshine delay3"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item unshine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item shine"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
						<div className="dotz__item shine"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item"></div>
						<div className="dotz__item "></div>
						<div className="dotz__item shine4"></div>
						<div className="dotz__item"></div>
						<div className="dotz__item"></div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item unshine4"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item shine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine delay4"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item"></div>
							<div className="dotz__item dotz__item--empty"></div>
							<div className="dotz__item dotz__item--empty"></div>
							<div className="dotz__item dotz__item--empty"></div>
							<div className="dotz__item dotz__item--empty"></div>
							<div className="dotz__item shine delay3"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row"></div>
					<div className="dotz__row"></div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item shine delay1"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine4"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item unshine4"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item shine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine delay3"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine delay3"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item "></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item unshine4"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine4 delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item shine"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item shine delay2"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item shine4"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine4"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine delay1"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item unshine delay2"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine delay3"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item unshine delay1"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine4"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item unshine delay3"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item shine delay3"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item shine delay2"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item shine4"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item shine delay1"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
					<div className="dotz__row">
						<div className="hide--mobile">
							<div className="dotz__item "></div>
							<div className="dotz__item shine delay2"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
							<div className="dotz__item "></div>
							<div className="dotz__item"></div>
							<div className="dotz__item"></div>
						</div>
					</div>
				</div>
				<div className="container">
					<h2 className="products__title hide--mobile">Дизайн-процесс</h2>
					<div className="hide--mobile">
						<div className="design__row design__row--top">
							<div className="design__item">
								<div className="line" />
								<div className="design__itemtitle">
									1. Продуктовое исследование
								</div>
								Мы глубоко исследуем рынок, собираем лучшие решения и предлагаем
								инновационные концепции.
							</div>
							<div className="design__item">
								<div className="line" />
								<div className="design__itemtitle">3. Визуальная стратегия</div>
								Разрабатываем логотип и готовим брендбук. Создаем визуальный
								язык будущего продукта.
							</div>
							<div className="design__item">
								<div className="line" />
								<div className="design__itemtitle">5. Прототип продукта</div>
								Собираем кликабельный прототип продукта на раннем этапе
								разработки.
							</div>
							<div className="design__item">
								<div className="line" />
								<div className="design__itemtitle">7. Упаковка</div>
								Сделаем лендинг, сайт или портал. Подготовим маркетинговые
								материалы.
							</div>
						</div>

						<div className="design__row design__row--bottom">
							<div className="design__item">
								<div className="line" />
								<div className="design__itemtitle">
									2. Техническая документация
								</div>
								Вместе формулируем требования. Определяем реальные сроки и
								бюджет.
							</div>
							<div className="design__item">
								<div className="line" />
								<div className="design__itemtitle">4. Дизайн-система</div>
								Документируем дизайн-правила. Строим UI-компоненты и
								прорабатываем UX-шаблоны.
							</div>
							<div className="design__item">
								<div className="line" />
								<div className="design__itemtitle">6. Дизайн продукта</div>
								Собираем проект на основе технического задания, прототипа,
								дизайн-системы и обратной связи.
							</div>
						</div>
					</div>

					<div className="slider">
						<Slider className="slider__init" {...settings}>
							<div className="slider__item">
								<img src={sl1} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl2} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl3} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl4} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl5} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl6} alt="" />
							</div>
							<div className="slider__item">
								<img src={sl7} alt="" />
							</div>

							<div className="slider__item">
								<img src={sl8} alt="" />
							</div>
						</Slider>
					</div>
				</div>

				<div className="container" id="contacts">
					{/* <footer className="footer">
						<img src={footer} alt="" className="decor" />
						<div
							className="footer__title"
							onClick={() => {
								navigate(`?modal`);
							}}
						>
							Напишите нам о своем проекте <img src={farrow} alt="" />
						</div>

						<div className="footer__contacts">
							<a href="mailto:contact@wjet.io">contact@wjet.io</a>
						</div>
					</footer> */}

					<Footer backgroundColor="transparent" />
				</div>
			</section>

			<ContactUsModal />
		</div>
	);
}

export default App;
